export default "__VITE_ASSET__13d59eb5__"